import Image from "next/image";
import { cn } from "@/lib/utils";

type RauchLogoWhitePropsT = {
  className?: string;
  width?: number;
  height?: number;
};

export function RauchLogoWhite({
  className,
  width = 180,
  height = 45,
}: RauchLogoWhitePropsT) {
  return (
    <Image
      src="/rauch-logo.svg"
      alt="Autohaus Rauch"
      width={width}
      height={height}
      className={cn("block w-auto brightness-0 invert", className)}
    />
  );
}
